import { animate, state, style, transition, trigger } from '@angular/animations';

export const flyInOut = trigger('flyInOut', [
  state('in', style({
    transform: 'translateX(0)',
    height: '*',
  })),
  transition(':enter, void => *', [
    style({
      transform: 'translateX(-100%)',
      height: '0px',
      opacity: 0,
    }),
    animate(150)
  ]),
  transition(':leave, void => *', [
    animate(150, style({
      transform: 'translateX(100%)',
      height: '0px',
      opacity: 0,
    }))
  ])
]);
